// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3d55R","checkboxCol":"Table_checkboxCol__1qjri","emailCol":"Table_emailCol__s3GRz","actionCol":"Table_actionCol__9wP4b"};